import {toCurrency, toPoints} from '@/shared/helpers'
export const TABLE_COLUMNS = [
  {
    Header: "Award Date",
    accessor: "awarded_at",
    Cell: ({ value }) => {
      let date = new Date(value).toLocaleDateString("en-US", {});
      return <span>{date}</span>;
    },
  },
  {
    Header: "Awarding Employee",
    accessor: "awarded_by",
    width: 120
  },
  {
    Header: "Receiving Employee",
    accessor: "awarded_to",
    width: 120
  },
  {
    Header: "Amount Awarded",
    accessor: "amount_awarded",
    Cell: ({ row, value }) => { return toCurrency(value); },
  },
  {
  Header: "Award Message",
  accessor: row =>
    row.award_message_updated
      ? row.award_message_updated
      : row.award_message,
  },
  {
    Header: "Peer Points Received",
    accessor: "points",
    Cell: ({ row, value }) => parseInt(value)
  },
  {
    Header: "Event Name",
    accessor: "event_name",
  },
  {
    Header: "Event Type",
    accessor: "event_type",
  },
  {
    Header: "Point To Award",
    accessor: "peer_balance",
    Cell: ({ row, value }) => parseInt(value)
  },

];
